// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge{border-radius:9999px;font-size:.8125rem;padding:.25rem .5rem}.badge-general-3{--tw-bg-opacity:1;background-color:#e4e2de;background-color:rgba(228,226,222,var(--tw-bg-opacity));--tw-text-opacity:1;color:#696867;color:rgba(105,104,103,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
